import { UnitTransferEscrowExceptionStatusEnumType } from '__generated__/graphql';

// OPS_APPROVED is HALF of a dual sign-off — it must never render as "Approved", which would read
// as fully resolved when legal has not yet signed off.
export default function unitTransferEscrowExceptionStatusToReadable(
  status: UnitTransferEscrowExceptionStatusEnumType
): { label: string; color: string } {
  switch (status) {
    case UnitTransferEscrowExceptionStatusEnumType.Pending:
      return { label: 'Pending Ops Approval', color: 'amber' };
    case UnitTransferEscrowExceptionStatusEnumType.OpsApproved:
      return { label: 'Ops Approved — Pending Legal Approval', color: 'amber' };
    case UnitTransferEscrowExceptionStatusEnumType.Approved:
      return { label: 'Fully Approved', color: 'green' };
    case UnitTransferEscrowExceptionStatusEnumType.Declined:
      return { label: 'Declined', color: 'red' };
    default:
      return { label: status, color: 'gray' };
  }
}
